export const namespaced = true;
export const state = function () {
  return {
    currentTabName: "",
    currentTabId: "",
    showChangeName: false,
  };
};

export const mutations = {};

export const actions = {};
